import React from "react"
import { Box, Button, Flex } from "@chakra-ui/react"
import Link from "@app/components/Link"
import { useRoutes } from "@app/hooks/useRoutes"

type Props = {
  suggestedSearchTerms?: any
}

const SearchSuggestedTerms: React.FC<Props> = ({ suggestedSearchTerms }) => {
  const { anyUrlResolver } = useRoutes()

  const links = suggestedSearchTerms?.map((term: any) => anyUrlResolver(term) || term)

  return (
    <Box pt={7.5} pb={5}>
      <Flex
        justifyContent="center"
        flexWrap={{ base: "wrap" }}
        whiteSpace={{ sm: "nowrap" }}
        alignItems="center"
        overflowX="auto"
        gap={"20px"}
      >
        {links?.map((searchTerm: any, index: number) => (
          <Link to={searchTerm?.shopify?.handle ? searchTerm?.url + "/" + searchTerm?.shopify?.handle : searchTerm.url}>
            <Button key={index} variant="secondary" size="small">
              {searchTerm?.title}
            </Button>
          </Link>
        ))}
      </Flex>
    </Box>
  )
}

export default React.memo(SearchSuggestedTerms)
